export default function NotFound() {
  return (
    <div className="container">
      <h1>404 – Page Not Found</h1>
    </div>
  );
}